import { render, staticRenderFns } from "./GestionTif.vue?vue&type=template&id=79a4a762"
import script from "./GestionTif.vue?vue&type=script&lang=js"
export * from "./GestionTif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports